<template>
  <div :id="id" :class="className" tabindex="-1"><slot v-if="visible" /></div>
</template>

<script>
import Popper from 'popper.js'
import { toggle } from '../constant/utils.js'

export default {
  name: 'Pop',
  props: {
    visible: { type: Boolean, default: false },
    targetId: { type: String, default: undefined },
    id: { type: String, default: 'popper-wrapper' },
    className: { type: String, default: '' },
    placement: { type: [String || Array], default: '' },
    container: { type: String, default: undefined },
  },
  watch: {
    visible(val, oldVal) {
      if (val === oldVal) return
      if (val) {
        document.addEventListener('click', this.handleClose)
        // 在 visible 变为 true 且有 targetId 时，确保 DOM 渲染后再初始化
        if (this.targetId) {
          this.$nextTick(() => {
            try {
              this.init()
            } catch (error) {
              console.error('Popper init error:', error)
            }
          })
        }
      } else {
        document.removeEventListener('click', this.handleClose)
        // 隐藏时销毁 popper 实例
        this.destroyPopper()
      }
    },
    targetId(val, oldVal) {
      if (!val || val === oldVal) return
      // 如果已经是 visible 状态，直接更新位置
      if (this.visible) {
        this.$nextTick(() => {
          try {
            this.init()
          } catch (error) {
            console.error('Popper init error:', error)
          }
        })
      } else {
        // 如果还未显示，设置 visible 为 true，init 会在 visible 的 watch 中执行
        this.$emit('update:visible', true)
      }
    },
  },
  created() {
    const _this = this
    this.handleClose = function(e) {
      const dom = e.target
      if (!toggle(dom, toggle, _this.id)) {
        _this.$emit('update:visible', false)
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时清理资源
    document.removeEventListener('click', this.handleClose)
    this.destroyPopper()
  },
  methods: {
    init() {
      // 先销毁已存在的 popper 实例
      this.destroyPopper()

      const reference = document.querySelector(`#${this.targetId}`)
      const warpper = document.querySelector(`#${this.id}`)

      if (!reference || !warpper) {
        console.warn('Popper init: reference or wrapper not found')
        return
      }

      this.popper = new Popper(reference, warpper, {
        // placement: this.placement || 'auto',
        preventOverflow: {
          boundariesElement: this.container ? this.$parent.$refs[this.container] : 'viewport',
        },
      })
    },
    destroyPopper() {
      // 销毁 popper 实例
      if (this.popper) {
        this.popper.destroy()
        this.popper = null
      }
    },
  },
}
</script>
